'use client'

import { $autoinspectorApi } from '@autoinspector/providers/autoinspector'
import { useApiError } from '@detail/hooks/useApiError'
//@ts-ignore
import { zodResolver } from '@hookform/resolvers/zod'
import Link from 'next/link'
import { useRouter } from 'next/navigation'
import { useCallback } from 'react'
import { useForm } from 'react-hook-form'
import { Button } from 'ui/button'
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from 'ui/form'
import { Input } from 'ui/input'
import { z } from 'zod'
import {
  SignInShell,
  SignInShellHeader,
  SignInShellHeaderDescription,
  SignInShellHeaderTitle,
} from '../guest/[guestId]/shell'
import { useToast } from 'ui/use-toast'

const schema = z.object({
  email: z
    .string()
    .min(1, 'Campo requerido')
    .email({ message: 'Email no válido' }),
})

type FormData = z.infer<typeof schema>

const FormComposition = () => {
  const form = useForm<FormData>({
    resolver: zodResolver(schema),
    defaultValues: {
      email: '',
    },
  })

  const router = useRouter()

  const { handleError } = useApiError()

  const { toast } = useToast()

  const mutation = $autoinspectorApi.useMutation(
    'post',
    '/v1/account/security/public/request/forgot-password',
    {
      onSuccess: () => {
        toast({
          title: 'Correo enviado',
          description:
            'Se ha enviado un correo para restablecer tu contraseña. Revisa tu bandeja de entrada y continua con las instrucciones indicadas.',
          variant: 'success',
        })

        router.push('/login')
      },
      onError: handleError,
    },
  )

  const handleSubmit = useCallback((body: FormData) => {
    mutation.mutate({
      body,
    })
  }, [])

  return (
    <Form {...form}>
      <form
        className='space-y-4 mt-4'
        onSubmit={form.handleSubmit(handleSubmit)}
      >
        <FormField
          control={form.control}
          name='email'
          render={({ field }) => {
            return (
              <FormItem>
                <FormControl>
                  <Input
                    {...field}
                    placeholder='Email'
                    className='rounded-xl border-slate-500 focus-visible:ring-0'
                  />
                </FormControl>
                <FormMessage />
              </FormItem>
            )
          }}
        />

        <Button
          type='submit'
          loading={mutation.isPending || mutation.isSuccess}
          className='text-base w-full bg-primary text-white hover:bg-primary hover:text-white h-11 border-0 rounded-[.625rem]'
          size='lg'
        >
          Continuar
        </Button>

        <div className='flex justify-center items-center !mt-2'>
          <Link href='/login'>
            <button className='text-slate-600 font-space-grotesk text-xs-plus font-medium leading-5 underline decoration-skip-ink-none'>
              Volver
            </button>
          </Link>
        </div>
      </form>
    </Form>
  )
}

export const ForgotPasswordForm = () => {
  return (
    <SignInShell>
      <SignInShellHeader>
        <SignInShellHeaderTitle>Recuperar contraseña</SignInShellHeaderTitle>
        <SignInShellHeaderDescription>
          Ingresa el correo electrónico asociado a la cuenta que deseas
          recuperar
        </SignInShellHeaderDescription>
      </SignInShellHeader>

      <FormComposition />
    </SignInShell>
  )
}
